export const common = {
	navigation: {
		moreCategories: 'More',
	},
	httpHandlers: {
		netPriceError:
			'NET price is currently not available at this time.  Please try again later or contact us at {{phoneNumber}} to confirm this product is available for you to purchase. For Service Parts issues or inquiries, please call 1-800-883-7535.',
		domainError:
			"Unfortunately, it's not possible to add product to the cart at the moment. Please try again later or contact us {{phoneNumber}}. For Service Parts issues or inquiries, please call 1-800-883-7535.",
		b2bUnitChanged: 'Cart has been updated for the current company.',
		validationErrors: {
			invalid: {
				code: 'Sorry the page or product you are looking for cannot be found.',
				purchaseOrderNumber: 'Please enter a valid P.O. Number'
			}
		},
		voucherAlreadyExist: 'Promo Code already applied.',
		voucherNotQualifyError: 'Promo Code does not qualify.',
		voucherExpiredError: 'Promo Code expired.',
		sppFormValidationErrorMessage: 'Please fill in all required fields before continuing to checkout',
		sppLeadProgramValidationErrorMessage: 'This lead number has been used previously and may not be used again. Please contact your Generac sales representative for assistance with this order.',
		sppLeadCartValidationErrorMessage: 'Please fill in all required fields before continuing to checkout',
	},
	pageMetaResolver: {
		favorites: {
			title: 'Favorites',
		},
		savedAddresses: {
			title: 'Saved Addresses',
		},
		category: {
			titleReferences: '{{refType}} for {{productName}}',
		},
		shippingAccounts: {
			title: 'Shipping Accounts',
		},
		search: {
			modelNumber: 'Model Number {{modelNumber}}'
		}
	},
	formErrors: {
		email: 'Is not a valid email address',
		duplicate: 'This email address is already in use. Please enter an email that is not being used by an active user or purchase a PowerPlay renewal.',
		invalidSerialNumber: 'The Serial Number entered is not valid. Please enter a new number or contact the Parts department at 800-883-7535.',
		destructionTypeRequired: 'Selection is required. Please indicate the method in which the non-functional engine will be destroyed.',
	},
	common: {
		apply: 'Apply',
		yes: 'Yes',
		ok: 'Ok',
		acknowledge: 'I acknowledge',
	},
	carousel: {
		viewAll: 'View All',
	},
	searchBox: {
		placeholder: 'Search products, models',
		spSearchMatches: '{{amount}} matches - select your model',
		findPartsCta: 'Need a specific part? Find Parts',
		spSearchBox: {
			placeholderModelNumber: "Start Typing Your Model (Eg. G00722310)",
			placeholderSerialNumber: "E.G., 601234DF43DF",
		}
	}
};